export const URL_BASE_USERS = "/admin/user";
export const URL_FETCH_USERS = `${URL_BASE_USERS}/list`;
export const URL_FETCH_JOBS = `${URL_BASE_USERS}/job`;
export const URL_FETCH_CIVILITIES = `${URL_BASE_USERS}/civility`;
export const URL_UPDATE_USER_STATUS = `${URL_BASE_USERS}/status/`;
export const URL_DELETE_TRAINING_SUPPLIER = `/admin/setting/training/`;
export const URL_RT_COUNTRIES = `${URL_BASE_USERS}/countries`;
